import parse from 'html-react-parser';
import { useEffect } from 'react';
import { useAppDispatch } from '../../redux/hooks';
import { useGetApiSettingsPublicBySettingTypeKeyQuery } from '../../redux/store/api/api';
import { settingTypeImprintText } from '../../shared/constants';
import { addMessage } from '../../redux/store/layout/slice';
import Loader from '../loader/Loader';

function ImprintText(): JSX.Element {
  const dispatch = useAppDispatch();
  const {
    data: imprintSetting,
    isFetching,
    isError,
    error,
  } = useGetApiSettingsPublicBySettingTypeKeyQuery({
    settingTypeKey: settingTypeImprintText,
  });

  useEffect(() => {
    if (isError) {
      dispatch(
        addMessage({
          id: 'GetSettingError',
          variant: 'danger',
          messageKeyBody:
            error && 'data' in error ? error.data?.messageKey : 'unknownError',
        }),
      );
    }
  }, [isError]);

  return (
    <>
      {isFetching && <Loader />}
      {!isFetching && imprintSetting?.resultObject?.value && (
        <>{parse(imprintSetting.resultObject.value || '')}</>
      )}
    </>
  );
}

export default ImprintText;
